import React, { useState, useEffect } from 'react';
import { FileDown, FileText, Mail, CheckCircle, AlertCircle } from 'lucide-react';

export default function DocumentosSoportePage() {
  const [documentosOriginal, setDocumentosOriginal] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [filtros, setFiltros] = useState({ numero: '', proveedor: '', estado: '', desde: '', hasta: '' });
  const [modalError, setModalError] = useState({ visible: false, errores: [] });

  useEffect(() => {
    const nombresProveedores = [
      "Proveedor A", "Proveedor B", "Proveedor C", "Logística Express S.A.S.", "Industrias La 25",
      "Comercializadora Los Andes", "Importadora Sol S.A.S.", "TecnoInsumos", "Abastecimientos Norte",
      "Papeles y Empaques", "Corporación Verde", "Textiles Colombia", "Agroinsumos de Occidente",
      "Ferretería Central", "Maderas Nacionales"
    ];

    const generarCUDE = () => {
      const hex = '0123456789abcdef';
      let cude = '';
      for (let i = 0; i < 56; i++) {
        cude += hex.charAt(Math.floor(Math.random() * hex.length));
      }
      return cude;
    };

    const allErrores = [
      { codigo: '801', descripcion: 'Documento soporte sin XML válido.' },
      { codigo: '802', descripcion: 'CUDE inválido.' },
      { codigo: '803', descripcion: 'Fecha de emisión no permitida.' },
      { codigo: '804', descripcion: 'Error en la firma digital.' },
      { codigo: '805', descripcion: 'Nit proveedor incorrecto.' },
    ];

    const mock = [];
    for (let i = 1; i <= 80; i++) {
      const numero = `DS-${10000 + i}`;
      const cliente = nombresProveedores[i % nombresProveedores.length];
      const fecha = new Date(2025, 4, Math.floor(Math.random() * 28) + 1).toLocaleDateString('es-CO');
      const valor = Math.floor(Math.random() * 4500000) + 50000;
      let estado = i % 3 === 0 ? 'Aceptado' : 'Rechazado';
      let erroresDian = [];
      if (estado === 'Rechazado') {
        erroresDian = [
          allErrores[Math.floor(Math.random() * allErrores.length)],
        ];
        if (Math.random() > 0.6) {
          erroresDian.push(allErrores[Math.floor(Math.random() * allErrores.length)]);
        }
      }
      mock.push({ numero, cliente, cude: generarCUDE(), fecha, valor, estado, erroresDian });
    }

    setDocumentosOriginal(mock);
    setDocumentos(mock);
  }, []);

  const aplicarFiltros = () => {
    let filtrados = documentosOriginal.filter(doc => {
      const fechaISO = doc.fecha.split('/').reverse().join('-');
      return (
        (!filtros.numero || doc.numero.includes(filtros.numero)) &&
        (!filtros.proveedor || doc.cliente.toLowerCase().includes(filtros.proveedor.toLowerCase())) &&
        (!filtros.estado || doc.estado === filtros.estado) &&
        (!filtros.desde || fechaISO >= filtros.desde) &&
        (!filtros.hasta || fechaISO <= filtros.hasta)
      );
    });
    setDocumentos(filtrados);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(documentos.length / rowsPerPage);
  const currentData = documentos.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  return (
    <div className="w-full max-w-7xl mx-auto px-2 sm:px-4 py-6 bg-[#f7fafd] min-h-[calc(100vh-120px)]">
      <div className="sticky top-0 z-40 bg-white shadow-lg rounded-xl border border-gray-200 p-4 mb-4">
        <h2 className="text-lg font-black text-[#003865] mb-5">Documentos Soporte Recibidos</h2>
        <div className="grid grid-cols-2 sm:grid-cols-7 gap-2 items-end text-xs">
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Nº Documento</label>
            <input type="text" value={filtros.numero} onChange={e => setFiltros({ ...filtros, numero: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
          </div>
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Proveedor</label>
            <input type="text" value={filtros.proveedor} onChange={e => setFiltros({ ...filtros, proveedor: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
          </div>
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Estado DIAN</label>
            <select value={filtros.estado} onChange={e => setFiltros({ ...filtros, estado: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200">
              <option value="">Todos</option>
              <option value="Aceptado">Aceptado</option>
              <option value="Rechazado">Rechazado</option>
            </select>
          </div>
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Fecha Desde</label>
            <input type="date" value={filtros.desde} onChange={e => setFiltros({ ...filtros, desde: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
          </div>
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Fecha Hasta</label>
            <input type="date" value={filtros.hasta} onChange={e => setFiltros({ ...filtros, hasta: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200" />
          </div>
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Filas</label>
            <select onChange={(e) => { setRowsPerPage(parseInt(e.target.value)); setCurrentPage(1); }} value={rowsPerPage} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div>
            <label className="block mb-1 text-gray-600 font-semibold">Buscar</label>
            <button onClick={aplicarFiltros} className="w-full px-2 py-2 bg-[#003865] text-white rounded-lg font-bold shadow hover:bg-blue-800">Buscar</button>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto rounded-2xl shadow-xl border border-gray-200 bg-white">
        <div className="overflow-y-auto max-h-[60vh]">
          <table className="min-w-[780px] w-full text-xs sm:text-[13px] text-gray-800">
          <thead>
                  <tr>
                    <th className="px-2 py-3 text-center font-bold uppercase tracking-wide w-[10%]">Numeración</th>
                    <th className="px-2 py-3 text-center font-bold uppercase tracking-wide w-[18%]">Proveedor</th>
                    <th className="px-2 py-3 text-center font-bold uppercase tracking-wide w-[12%]">CUDE</th>
                    <th className="px-2 py-3 text-center font-bold uppercase tracking-wide w-[12%]">Fecha</th>
                    <th className="px-2 py-3 text-center font-bold uppercase tracking-wide w-[12%]">Valor</th>
                    <th className="ppx-2 py-3 text-center font-bold uppercase tracking-wide w-[12%]">Estado</th>
                    <th className="px-2 py-3 text-center font-bold uppercase tracking-wide w-[12%]">Acciones</th>
                  </tr>
                </thead>

            <tbody>
              {currentData.map((d, index) => (
                <tr key={index} className={`border-t ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-blue-50 transition`}>
                  <td className="px-2 py-2 border-b border-gray-100 text-left font-semibold tracking-wide">{d.numero}</td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">
                    <span className="text-[15px] font-bold text-[#003865]">{d.cliente}</span>
                  </td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">
                    <span
                      className="block max-w-[260px] font-mono px-2 py-1 rounded bg-gray-100 text-gray-700 text-xs cursor-pointer select-all whitespace-nowrap hover:bg-gray-200 transition"
                      title={d.cude}
                      tabIndex={0}
                      style={{
                        WebkitUserSelect: 'all',
                        userSelect: 'all',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      {d.cude}
                    </span>
                  </td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">{d.fecha}</td>
                  <td className="px-2 py-2 border-b border-gray-100 text-right font-bold text-blue-900">{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(d.valor)}</td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">
                    <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold relative border ${d.estado === 'Aceptado'
                        ? 'bg-green-50 text-green-700 border-green-100'
                        : 'bg-yellow-50 text-yellow-900 border-yellow-200'
                      }`}
                      style={{ minWidth: 104, justifyContent: 'center' }}
                    >
                      {d.estado === 'Aceptado'
                        ? <CheckCircle className="h-4 w-4" />
                        : <button
                            className="hover:bg-yellow-100 rounded-full transition"
                            style={{ padding: 2, marginRight: 2 }}
                            onClick={() => setModalError({ visible: true, errores: d.erroresDian })}
                            title="Ver detalle del error DIAN"
                            type="button"
                          >
                            <AlertCircle className="w-4 h-4 text-yellow-800" />
                          </button>
                      }
                      <span className="ml-1">{d.estado}</span>
                    </span>
                  </td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">
                    <div className="flex justify-center gap-2">
                      <button title="Descargar XML" className="flex flex-col items-center text-gray-600 hover:text-blue-600 transition-all">
                        <FileDown className="h-4 w-4" /><span className="text-[10px]">XML</span>
                      </button>
                      <button title="Ver PDF" className="flex flex-col items-center text-red-500 hover:text-red-700 transition-all">
                        <FileText className="h-4 w-4" /><span className="text-[10px]">PDF</span>
                      </button>
                      <button title="Reenviar Mail" className="flex flex-col items-center text-blue-500 hover:text-blue-700 transition-all">
                        <Mail className="h-4 w-4" /><span className="text-[10px]">Mail</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {currentData.length === 0 && (
                <tr>
                  <td colSpan={7} className="py-8 text-center text-gray-400 font-medium">
                    No hay documentos encontrados para los filtros seleccionados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 rounded-b-2xl shadow p-3 flex flex-wrap gap-2 justify-between items-center text-xs z-20">
            <span className="font-semibold text-gray-600">
              Página {currentPage} de {totalPages}
            </span>
            <div className="flex gap-1 items-center flex-wrap">
              <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="px-2 py-1 border rounded-lg disabled:opacity-40 hover:bg-blue-100 font-semibold" title="Primera página">«</button>
              <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} className="px-2 py-1 border rounded-lg disabled:opacity-40 hover:bg-blue-100 font-semibold">Anterior</button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button key={page} onClick={() => setCurrentPage(page)} className={`px-2 py-1 border rounded-lg hover:bg-blue-100 font-semibold ${page === currentPage ? 'bg-[#003865] text-white' : ''}`}>{page}</button>
              ))}
              <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} className="px-2 py-1 border rounded-lg disabled:opacity-40 hover:bg-blue-100 font-semibold">Siguiente</button>
              <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} className="px-2 py-1 border rounded-lg disabled:opacity-40 hover:bg-blue-100 font-semibold" title="Última página">»</button>
            </div>
          </div>
        </div>
      </div>

      {modalError.visible && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-2 relative">
            <button
              onClick={() => setModalError({ visible: false, errores: [] })}
              className="absolute top-2 right-3 text-gray-400 hover:text-gray-700 text-2xl"
            >
              ×
            </button>
            <div className="p-6">
              <h4 className="text-lg font-bold text-yellow-900 mb-4 flex items-center gap-2">
                <AlertCircle className="w-5 h-5 text-yellow-700" /> Detalle de Rechazo DIAN
              </h4>
              <table className="w-full mb-3 border text-xs">
                <thead>
                  <tr className="bg-gray-50 text-[#003865]">
                    <th className="px-2 py-2 border-b border-r font-semibold">Código</th>
                    <th className="px-2 py-2 border-b font-semibold">Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {modalError.errores.map((err, idx) => (
                    <tr key={idx}>
                      <td className="px-2 py-2 border-b border-r">{err.codigo}</td>
                      <td className="px-2 py-2 border-b">{err.descripcion}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button
                className="bg-[#003865] text-white px-6 py-2 rounded-xl font-bold shadow hover:bg-blue-700 transition"
                onClick={() => setModalError({ visible: false, errores: [] })}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
